import {useState} from 'react';
import styles from './ViewerImage.module.scss';
import ICON_RELOAD from '../../../public/static/viewer/icon-reload.svg';
import Button from '../../common/component/Button';

interface IProps {
  src?: string;
  isScrollViewImg?: boolean;
  // TODO: 기능 구현시 타입 변경
  reload?: () => void;
}

export default function ViewerImage({
  src,
  isScrollViewImg = false,
  reload,
}: IProps) {
  const [imgState, setImgState] = useState<IImageState>('loading');

  const onClickReload = () => {
    setImgState('loading');
    reload?.();
  };

  return (
    <div
      className={cn('relative w-full h-full bg-white', {
        [styles.checkBg]: imgState !== 'load',
      })}
    >
      {src && (
        <img
          className={cn(
            'absolute w-full block max-h-full max-w-full object-contain ',
            'inset-0 m-auto pointer-events-none',
            {
              invisible: imgState !== 'load',
              'w-full h-full m-0': isScrollViewImg,
            }
          )}
          src={src}
          alt=""
          onError={() => setImgState('error')}
          onLoad={() => setImgState('load')}
        />
      )}
      {imgState === 'error' && (
        <Button
          className={cn(
            'h-56 w-56 absolute bg-white inset-0 m-auto',
            'rounded-50per border border-solid border-grey-13'
          )}
          onClick={() => onClickReload()}
        >
          <img src={ICON_RELOAD} alt="reload" />
        </Button>
      )}
    </div>
  );
}

type IImageState = 'loading' | 'load' | 'error';
